import React from "react";
import StarRating from "../Form/StarRating";
import ProfileImage from "../../components/Common/ProfileImage";
import { formatYYYY_MM_DD } from "../../utils/dateFormating";

const ReviewCard = ({
  customerFeedback,
  rating,
  createdAt,
  price,
  firstName,
  lastName,
  profilePicture,
  role,
}) => {
  return (
    <div className="border rounded-lg sm:rounded-[12px] flex flex-col gap-4 sm:gap-6 border-light-blue p-4 sm:p-6">
      <div className="flex flex-col gap-3">
        <div className="flex flex-row gap-4 items-center">
          <div className="flex justify-center items-center w-[64px] h-[64px] rounded-full ">
            <ProfileImage
              profilePicture={profilePicture}
              firstName={firstName}
              lastName={lastName}
              fontSize="text-[20px]"
            />
          </div>
          <div>
            <h3 className="font-inter font-semibold text-base sm:text-[18px] text-dark leading-6">
              {firstName} {lastName}
            </h3>
            <span className="font-inter font-medium text-sm sm:text-level-6 text-content leading-6">
              {role}
            </span>
          </div>
        </div>
        <hr />
      </div>
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-3">
          <StarRating rating={rating} />
          <span className="font-inter text-sm sm:text-level-5 leading-6 text-content">
            {rating == 0 ? "" : rating}
          </span>
        </div>
        <p className="font-inter text-sm sm:text-level-5 leading-6 text-content">
          {customerFeedback}
        </p>
        <div className="flex gap-6 sm:gap-10 items-center">
          <div>
            <h5 className="font-inter font-semibold text-sm sm:text-level-5 leading-6 text-content">
              Date
            </h5>
            <span className="font-inter text-xs sm:text-level-6 leading-6 text-content">
              {formatYYYY_MM_DD(createdAt)}
            </span>
          </div>
          <div>
            <h5 className="font-inter font-semibold text-sm sm:text-level-5 leading-6 text-content">
              Price
            </h5>
            <span className="font-inter text-xs sm:text-level-6 leading-6 text-content">
              ${price}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
